import { jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState } from "react";
import { getUserTrackingIntent } from "./utils.js";
const TrackingContext = /*#__PURE__*/ createContext(void 0);
const TrackingProvider = ({ children })=>{
    const [intent, setIntent] = useState(null);
    const clearIntent = ()=>{
        setIntent(null);
    };
    useEffect(()=>{
        const userIntent = getUserTrackingIntent();
        if (userIntent) setIntent(userIntent);
    }, []);
    return /*#__PURE__*/ jsx(TrackingContext.Provider, {
        value: {
            formattedIntent: intent ? {
                upperFunnelJobToBeDone: intent.jobToBeDone,
                upperFunnelSource: intent.source,
                upperFunnelUrlSource: intent.urlSource
            } : {},
            setIntent: (_intent)=>{
                setIntent({
                    ..._intent,
                    urlSource: window.location.href
                });
            },
            clearIntent
        },
        children: children
    });
};
export { TrackingContext, TrackingProvider };
